/*
 * @Author: 赵修瞾
 * @Date: 2020-04-16 09:25:55
 * @LastEditors: 赵修瞾
 * @LastEditTime: 2020-05-13 14:30:44
 * @FilePath: \www\src\store\state.js
 * @Description:
 */
const state = {
    // 版本号
    version: '1.2.4',
    // 是否开发模式
    isDev: false,
    // 是否微信环境
    isWeiXin: false,

    // 商城首页广告是否显示
    isGuide: false,
    // 导航标题
    topBarTitle: '',
    // 底部导航栏默认选中项
    tabSelectIndex: '',

    // 定位相关
    // 定位数据
    locationList: [],
    // 当前所选定位信息
    localValue: '',
    // 当前gps定位
    gpsValue: '',

    // 汽车商品分类
    classifyList: [],

    // 汽车商城搜索条件
    queryParams: null,
    // 用户相关
    // 用户是否登录
    isLogin: false,
    // 是否首次登录
    // 退出登录后重新登录就是首次登录
    isFirstLogin: false,
    // 用户openid
    openid: '',
    // token
    h5authorization: '',
    // 用户信息
    userInfo: null,

    // 服务热线
    tell: "02861521022",

    // 不需要登录校验的页面
    unCkLoginList: [
        'ShopHome',
        'ClassifyHome',
        'CarDrivingList',
        'UserLogin',
        'DealInfo'
    ],
    // 是否八保舟
    isApp: false,
    // 是否可以切换到商城模式
    isGoAms: false,
    // 中国省市县
    chinaAddress: null
}
export default state